"use client";
import { useMemo } from "react";
import { count_units } from "@core/helpers/client/hooks/useProduct";
import { handle_attribute_separator } from "@core/helpers/string";

const only_number_pattern = /^[\d۰-۹٠-٩.,٫\/\s×x*-]+$/;

const with_unit = (value, unit) => {
    const unit_title = count_units[unit]?.title;

    if (!unit_title) return value;
    if (value === null || value === undefined || value === "") return value;

    const text = String(value).trim();
    if (!only_number_pattern.test(text)) return text;

    return `${text} ${unit_title}`;
};

const AllInformation = ({ data }) => {

    const specs = useMemo(() => {
        if (!data?.attribute_groups) return [];

        return data?.attribute_groups.map((group) => ({
            title: group.attribute_group.title,
            attributes: group.attributes || []
        }));

    }, [data?.attribute_groups]);

    if (!specs.length) return null;

    // console.log('data?.attribute_groups', data?.attribute_groups)
    return (
        <div>

            <div className="space-y-4 lg:space-y-8">
                {specs
                    .filter(group => group.attributes?.length)
                    .map((group, i) => (

                        <div key={i}>
                            <h3 className="text-jmt-neutral-800 font-bold text-sm lg:text-base pb-3"> {group?.title} </h3>
                            <div className="">
                                {group.attributes.map((item, index) => {

                                    let value;

                                    /* if attribute toggle (type === 3)*/
                                    if (item?.attribute?.type === 3) {
                                        const boolVal = item?.attribute_value?.value;
                                        value = item?.attribute?.options?.[boolVal ? 0 : 1]?.title;
                                    }

                                    /* if attribute boolean (type === 5) */
                                    else if (item?.attribute?.type === 5) {
                                        const key = item?.attribute_value?.value;

                                        switch (key) {
                                            case "brand":
                                                value = data?.brand?.title || "-";
                                                break;
                                            case "category":
                                                value = data?.category?.title || "-";
                                                break;
                                            default:
                                                value = key || "-";
                                        }
                                    }

                                    /* if attribute number (type === 6) */
                                    else if (item?.attribute?.type === 6) {

                                        let values = item?.attribute_value?.value;
                                        let units = item?.attribute_value?.unit;

                                        if (!Array.isArray(values)) {
                                            values = [values];
                                        }

                                        if (!Array.isArray(units)) {
                                            units = [units];
                                        }

                                        const unitTitles = units.map(u => count_units[u]?.title || "");

                                        const allSameUnit = units.length > 1 && units.every(u => u === units[0]);

                                        if (values.length === 1) {

                                            value = `${values[0]} ${unitTitles[0] || ""}`;
                                        }
                                        else if (allSameUnit) {

                                            value = `${values.join(" / ")} ${unitTitles[0]}`;
                                        }
                                        else {

                                            value = values
                                                .map((val, i) => `${val} ${unitTitles[i] || ""}`)
                                                .join(" / ");
                                        }
                                    }

                                    /* if attribute (type === 4,7) */
                                    else if ([4, 7].includes(item?.attribute?.type)) {

                                        let values = item?.attribute_value?.value;

                                        if (!Array.isArray(values)) {
                                            values = [values];
                                        }

                                        value = handle_attribute_separator(item?.attribute?.separator, values);
                                    }

                                    /* else other type */
                                    else {
                                        const unit = item?.attribute_value?.unit;

                                        value = Array.isArray(item?.attribute_value?.value)
                                            ? item.attribute_value.value
                                                .map(val => with_unit(val, unit))
                                                .join(" ، ")
                                            : with_unit(item?.attribute_value?.value, unit);
                                    }

                                    return (
                                        <div
                                            key={index}
                                            className="grid grid-cols-12 space-x-3 text-sm">

                                            <div className="col-span-5 bg-jmt-neutral-50 md:whitespace-pre-line break-words min-w-0 text-jmt-neutral-500 px-2 lg:px-3 py-2 my-1">
                                                {item?.attribute?.title}
                                            </div>

                                            <div className="col-span-7 bg-jmt-neutral-50 md:whitespace-pre-line break-words min-w-0 text-jmt-main px-2 lg:px-3 py-2 my-1">
                                                {value || "-"}
                                            </div>

                                        </div>
                                    );
                                })}

                            </div>
                        </div>
                    ))}

            </div>

        </div>
    );
}


export default AllInformation;